import * as Api from "shared/util/ReCaptcha";

export function confirmToken({ type, token, isCaptchaShowing, page, href }) {
	return (dispatch) => {
		if (!token) {
			return;
		}

		Api.confirmToken(token)
			.then((resp) => {
				if (!resp.value.success) {
					return null;
				}

				return dispatch({
					type,
					payload: {
						score: resp.value.score,
						isCaptchaShowing,
						page,
						href,
					},
				});
			});
	};
}



// WEBPACK FOOTER //
// ./src/ducks/recaptcha.js